/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
import { Box } from '@mui/material';
import AccessLogSection from '../subComponents/AccessLogSection';
import DeliveryTrackingSection from '../subComponents/DeliveryTrackingSection';
import { CustomStyleIconCircleContainer } from '../../../../../components/Styles';
import {
    DocumentPlus,
    FileTracking,
} from '../../../../../components/buttons/IconButtons';
import ExportDataBtn from '../../../../../components/buttons/ExportDataBtn';

import { STATUS_MODEL, status } from '../../../../../enums/statusEnum';
import CustomUserChip from "../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import {getValueByKey} from "../../../../../Apis/functions";
import {SEARCH_MODEL} from "../../../../../components/table/Model/TableModel";

//Model for Equipment and Material entities.
export const EQUIPMENT_AND_MATERIAL_MODEL = {
    id: null,
    name: '',
    code: null,
    statusId: '',
    categoryId: '',
    subCategoryId: '',
    brand: '',
    model: '',
    serialNumber: '',
    equipmentOwner: null,
    specification: '',
    isValidGeneralDetails: function () {
        return this.name !== '' && this.code !== '' && this.code !== null;
    },
    isValidTechnicalDetails: function () {
        return this.brand !== '' && this.model !== '' && this.serialNumber !== '' && this.equipmentOwner !== '' && this.equipmentOwner !== null ;
    },
    toRegister: function ({ categoryId = null, subCategoryId = null, contractorId = null }) {
        return {
            name: this.name,
            code: this.code,
            brand: this.brand,
            model: this.model,
            serialNumber: this.serialNumber || null,
            equipmentOwner: getValueByKey(this.equipmentOwner, 'name', MATERIAL_TYPE),
            contractorId: contractorId || null,
            categoryId: categoryId || null,
            subCategoryId: subCategoryId || null,
            specification: this.specification || null,
            statusId: this.statusId === '' || this.statusId == null ? STATUS_MODEL.ACTIVE : this.statusId,
        };
    },
    set: function (data) {
        return {
            ...this,
            id: data.id,
            name: data.name,
            code: data.code,
            statusId: data.statusId,
            categoryId: data.categoryId,
            subCategoryId: data.subCategoryId,
            brand: data.brand,
            model: data.model,
            serialNumber: data.serialNumber,
            specification: data.specification,
            equipmentOwner:getValueByKey(data.equipmentOwner, 'name', MATERIAL_TYPE),
        };
    },
    clearGeneralDetails: function (currentItem) {
        return {
            ...currentItem,
            id: null,
            name: '',
            code: null,
            status: '',
        };
    },
    clearTechnicalDetails: function (currentItem) {
        return {
            ...currentItem,
            brand: '',
            model: '',
            serialNumber: '',
            equipmentOwner: null,
            specification: '',
        };
    },
};
//Tab configuration for the "Equipment and Material" update flow.
export const STEPS_EQUIPMENT_AND_MATERIAL = {
    GENERAL_DETAILS: {
        INDEX: 0,
        TRANS: 'general_details',
    },
    TECHNICAL_DETAILS: {
        INDEX: 1,
        TRANS: 'technical_details',
    },
    PHOTO: {
        INDEX: 2,
        TRANS: 'photo',
    },
    SUMMARY: {
        INDEX: 3,
        TRANS: 'summary',
    },
};
// Material ownership types.
export const MATERIAL_TYPE = {
    CONTRACTOR_OWNER: {
        ID: 1,
        name: "CONTRACTOR_OWNER",
        trans: 'contractor_owned',
    },
    CLIENT_OWNER: {
        ID: 2,
        name: "CLIENT_OWNER",
        trans: 'client_owned',
    },
};

export const CATEGORY_TYPE = {
    CATEGORY: 'CATEGORY',
    SUBCATEGORY: 'SUBCATEGORY',
};

export const categoryToChipOption = (list = []) =>
    list.map((item) => ({
        label: item.name,
        id: item.id,
    }));

export const EQUIPMENT_MATERIAL_SECTION_MODEL = {
    ACCESS_LOG: 'access_log',
    DELIVERY_TRACKING: 'delivery_tracking',
};

export const getSections = ( materialType) => {
    const sections = [
        {
            id: 1,
            key: EQUIPMENT_MATERIAL_SECTION_MODEL.ACCESS_LOG,
            label: 'access_log',
            icon: <DocumentPlus className='w-20px h-20px' />,
            content: () => <AccessLogSection/>,
        },
        {
            id: 2,
            key: EQUIPMENT_MATERIAL_SECTION_MODEL.DELIVERY_TRACKING,
            label: 'delivery_tracking',
            icon: <FileTracking className='w-20px h-20px' />,
            content: () => (
                <DeliveryTrackingSection />
            ),
        },
    ];

    if (materialType === MATERIAL_TYPE.CONTRACTOR_OWNER.name) {
        return sections.filter((s) => s.key !==  EQUIPMENT_MATERIAL_SECTION_MODEL.DELIVERY_TRACKING);
    }

    return sections;
};



export const getColumns = ({ t, id, moduleId, option, statusId, statusData, chipClass, dispatch }) => [
    {
        field: 'label',
        label: 'description',
        classTableCell: 'w-100',
        render: (val, row) => (
            <div className='d-flex align-items-center gap-2 w-100 mt-3 mb-3'>
                <Box sx={CustomStyleIconCircleContainer}>{row.icon}</Box>
                <p className='fs-14px font-color-text-950 ibl-font-w-600 m-0'>{t(val)}</p>
            </div>
        ),
    },
    {
        field: 'label',
        label: '',
        render: (val, row) => {
            const body = SEARCH_MODEL.setObject({
                page:0,
                size: 20,
                model: option,
                userId: id,
            });
            return row.key === EQUIPMENT_MATERIAL_SECTION_MODEL.ACCESS_LOG ? (
                <ExportDataBtn
                    moduleId={moduleId}
                    body={body}
                    option={option}
                    search={false}
                    contractorSupplier={false}
                />
            ) : (
                <>
                    {statusId && (
                        <CustomUserChip
                            name={t(status[statusId])}
                            Icon={statusData?.Icon}
                            showAvatar={true}
                            iconPosition={POSITION_MODEL.LEFT}
                            className={chipClass}
                        />
                    )}
                </>
            );
        }},
];

export const DELIVERY_MODEL = {
    dateTime: null,
    employee: null,
    deliveryNote: null,
    toRegister: function ({ equipmentId, deliveryById, statusId }) {
        return {
            equipmentId,
            deliveryById,
            statusId,
            deliveryDate: this.dateTime ? new Date(this.dateTime).getTime() : null,
            deliveryNote: this.deliveryNote || null,
        };
    },
    clear: function () {
        this.dateTime = null;
        this.employee = null;
        this.deliveryNote = null;
        return this;
    },
    isValid: function () {
        return this.dateTime !== null && this.deliveryNote !== null && this.deliveryNote.trim() !== '';
    },
};

export const ACTIVITY_TRACKER_ITEM_MODEL = {
    equipmentDeliveryId: null,
    userId: null,
    message: null,
    createdAt: null,
    toRegister: function ({equipmentDeliveryId, userId, message}) {
        return {
            equipmentDeliveryId: equipmentDeliveryId,
            userId: userId,
            message: message || null,
            createdAt: Date.now(),
        };
    },
    clear: function () {
        return {
            ...this,
            equipmentDeliveryId: null,
            userId: null,
            message: null,
            createdAt: null
        };
    },
    isValid: function ({ message }) {
        return (message !== null && message.trim() !== '');
    },
};

export const DELIVERY_ASSET_TYPE = {
    DELIVERY: 'DELIVERY',
    CLOSED: 'CLOSED',
};


export const CLOSE_DELIVERY_MODEL = {
    id: null,
    equipmentId: null,
    statusId: null,

    closedDate: null,
    closedById: null,
    closedByFullName: null,
    closedByEmail: null,
    closedByPhoneNumber: null,
    closedNote: null,
    closedFile: null,

    deliveryDate: null,
    deliveryById: null,
    deliveryByFullName: null,
    deliveryByEmail: null,
    deliveryByPhoneNumber: null,

    set: function () {
        return {
            id: this.id,
            equipmentId: this.equipmentId,
            statusId: this.statusId,

            closedDate: this.closedDate,
            closedById: this.closedById,
            closedByFullName: this.closedByFullName,
            closedByEmail: this.closedByEmail,
            closedByPhoneNumber: this.closedByPhoneNumber,
            closedNote: this.closedNote,
            closedFile: this.closedFile,

            deliveryDate: this.deliveryDate,
            deliveryById: this.deliveryById,
            deliveryByFullName: this.deliveryByFullName,
            deliveryByEmail: this.deliveryByEmail,
            deliveryByPhoneNumber: this.deliveryByPhoneNumber,
        };
    },

    toRegister: function ({ delivery, equipment, userId, comment }) {
        return {
            ...this,
            id: delivery?.id || null,
            equipmentId: equipment?.id || null,
            statusId: equipment?.statusId || null,

            closedDate: Date.now(),
            closedById: userId || null,
            closedByFullName: null,
            closedByEmail: null,
            closedByPhoneNumber: null,
            closedNote: comment || null,
            closedFile: null,

            deliveryDate: delivery?.deliveryDate || null,
            deliveryById: delivery?.deliveryById || null,
            deliveryByFullName: delivery?.deliveryByFullName || null,
            deliveryByEmail: delivery?.deliveryByEmail || null,
            deliveryByPhoneNumber: delivery?.deliveryByPhoneNumber || null,
        };
    },
};
